import React from "react";

import { Button } from "@samskip/frontend-components";
import { useTranslation } from "react-i18next";

import { CommonTypes, UserProfileViewModel } from "@assets/types";
import { CompanyPicker } from "@components";

import LanguageSwitcher from "./languageSwitcher";
import Notifications from "./notifications";

type UserInfoProps = {
  userProfile?: UserProfileViewModel;
  logout: CommonTypes.CallbackFunction;
};

const UserInfo = ({ userProfile, logout }: UserInfoProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex gap-2">
      {userProfile?.User && userProfile.User.ID && (
        <>
          <Notifications />
          <span className="uppercase font-bold">
            {userProfile.User.Username}
          </span>
          <CompanyPicker
            company={userProfile.SelectedCompany}
            userCompanies={userProfile.Companies}
            userIsEmployee={
              (userProfile ? userProfile.Access.UserType : "") !== "C"
            }
          />
        </>
      )}
      {/* Logout */}
      {userProfile?.User && userProfile.User.ID && (
        <Button
          className="uppercase"
          color="neutral-700"
          onClick={logout}
          variant="text"
        >
          {t("TEXT_LOGOUT")}
        </Button>
      )}

      <LanguageSwitcher />
    </div>
  );
};

export default UserInfo;
